import React, {useCallback, useContext, useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {useHttp} from '../hooks/http.hook'
import config from '../config.json'
import {ModalWin} from "../elements/ModalWin"
import {LoaderClass} from "../elements/LoaderClass"
import {objectLang, setErrorWindow, setLocalStorageItem} from "../functions"
import {AuthContext} from "../context/AuthContext"
import {NoteViewCardClass} from "../components/NoteViewCardClass"

export const NoteSharePage = () => {
    setLocalStorageItem('page', 'NoteSharePage')
    const auth = useContext(AuthContext)
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const [note, setNote] = useState({})
    const {request, loading} = useHttp()
    const navigate = useNavigate()
    const code = useParams().code

    const getData = useCallback(async () => {
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        try {
            const data = await request(
                `${host}/api/note/open-share/${code}`, 'GET')

            if (data.status > 200) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code, '', '', '', '', 'replaceToMain'))
                return
            }

            setNote(data.note)

        } catch (e) {

        }
    }, [code, request])

    useEffect(() => {
        getData().then()
    }, [getData])

    const closeNoteHandler = () => {
        const l = objectLang().language.lang
        window.location.replace(`/${l}/folder/open/${note.parentFolder}`)
    }

    if (loading) {
        return <LoaderClass />
    }

    if (!allowed) {
        return (
            <>
                <ModalWin data={dataModal}/>
            </>
        )
    }

    return (
        <>
            <NoteViewCardClass
                auth={auth}
                note={note}
                saveNoteHandler={null}
                closeNoteHandler={closeNoteHandler}
                navigate={navigate}
            />
        </>
    )
}
